import { forwardRef } from 'react';

const Card = forwardRef(
  (
    {
      children,
      className = '',
      idCard = '',
      onMouseEnter,
    }: {
      children: React.ReactNode;
      className?: string;
      idCard?: string;
      onMouseEnter?: React.MouseEventHandler<HTMLDivElement>;
    },
    ref: React.LegacyRef<HTMLDivElement>
  ) => {
    return (
      <div id={idCard || null} ref={ref} className={className} onMouseEnter={onMouseEnter}>
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';

export default Card;
